module.exports = __webpack_public_path__ + "database-technology.2-0DyhDc.svg";